import { createSlice } from '@reduxjs/toolkit';
import type { ValidateSliceCaseReducers, SliceCaseReducers } from '@reduxjs/toolkit';

import { IHelpCenterState } from '@sv-support-sdk/shared-types/src/store/helpCenter';
import { SUPPORT_VOTED_TOPICS } from '@sv-support-sdk/utils/src/constants/articles';

export const initialState: IHelpCenterState = {
  categories: [],
  topics: {},
  // @ts-expect-error JSON.parse can handle null value
  voted: JSON.parse(localStorage.getItem(SUPPORT_VOTED_TOPICS)) || [],
  loading: {
    categories: false,
    topics: false,
  },
};

const createHelpCenterSlice = <T extends IHelpCenterState, Reducers extends SliceCaseReducers<T>>({
  name = 'helpCenter',
  initialState,
  reducers,
}: {
  name: string;
  initialState: T;
  reducers: ValidateSliceCaseReducers<T, Reducers>;
}) => {
  return createSlice({
    name,
    initialState,
    reducers: {
      setCategories: (state, action) => ({
        ...state,
        categories: action.payload,
      }),
      setTopics: (state, action) => ({
        ...state,
        topics: action.payload,
      }),
      updateTopic: (state, action) => ({
        ...state,
        topics: {
          ...state.topics,
          [action.payload.categorySlug]: state.topics[action.payload.categorySlug].map((el) =>
            el.id !== action.payload.id ? el : { ...el, ...action.payload },
          ),
        },
      }),
      voteTopic: (state, action) => ({
        ...state,
        voted: [...state.voted, action.payload],
      }),
      setCategoriesLoading: (state, action) => {
        // eslint-disable-next-line no-param-reassign
        state.loading.categories = action.payload;
      },
      setTopicsLoading: (state, action) => {
        // eslint-disable-next-line no-param-reassign
        state.loading.topics = action.payload;
      },
      ...reducers,
    },
  });
};

export default createHelpCenterSlice;
